module.exports = __webpack_public_path__ + "media/זקן.77e9408e.mp3";